import { Button, breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const ButtonShadefinderWrapper = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.625rem 1.5rem;
  margin: 1rem 0;
  width: 100%;

  @media (min-width: ${breakpoints.md}) {
    margin: 0.75rem 0;
  }

  &:focus {
    background-color: ${theme.color.background.primary};
  }

  &:hover {
    background-color: ${theme.color.background.primaryHover};
  }
`;
